import { FC } from 'react'
import AddIcon from '@mui/icons-material/Add'

import { SvgIconProps } from '@mui/material/SvgIcon'

export const PlusIcon: FC<SvgIconProps> = (props: SvgIconProps) => {
  return <AddIcon {...props} />
}
